import React from 'react';

const BurgerIcon = ({ width = 24, height = 19, color = 'white', ...props }) => (
  <svg width={width} height={width} viewBox={`0 0 ${width} ${height}`} fill="none" {...props}>
    <path d="M24 1H0" stroke={color} strokeWidth="2" />
    <path d="M24 9.40002H0" stroke={color} strokeWidth="2" />
    <path d="M24 17.8H0" stroke={color} strokeWidth="2" />
  </svg>
);

export default BurgerIcon;
